import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwapHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.354 3.146a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.707-.708L12.293 6H3a.5.5 0 0 1 0-1h9.293l-1.94-1.854a.5.5 0 0 1 0-.708l.001-.292zM5.646 7.146a.5.5 0 0 1 0 .708L3.707 10H13a.5.5 0 0 1 0 1H3.707l1.94 1.854a.5.5 0 0 1-.708.707l-2.5-2.5a.5.5 0 0 1 0-.707l2.5-2.5a.5.5 0 0 1 .707 0z"
	})]
});
const ForwardRef = forwardRef(SvgSwapHorizontal);
export default ForwardRef;
